module.exports = __webpack_public_path__ + "static/media/solid-down.df635937.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/solid-down.svg
// module id = 1172
// module chunks = 0